import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createProdGroup, deleteProdGroup, selectProdGroup, updateProdGroup, removeSelectedProdGroup, fetchProdGroups } from '../../../store/ProdGroupSlice';
import { AppDispatch, RootState } from '../../../store/store';
import Placeholder from '../../UI/Placeholder/Placeholder';
import Card from '../../UI/Card/Card';
import IconButton from '../../UI/IconButton/IconButton';
import AddIcon from '../../UI/icons/AddIcon/AddIcon';
import SettingsForm from '../SettingsForm/SettingsForm';
import SettingsList from '../SettingsList/SettingsList';
import AreaLoader from '../../UI/AreaLoader/AreaLoader';
import useForm from '../../../hooks/useForm';
import classes from './ProdGroups.module.css';
import { groupFormValidator } from '../../../utils/validators';

const INIT_INPUT = { name: '', description: '', url: 'Размер' };

const OPTIONS = ['Размер', 'Комплектация', 'Цвет'];

const ProdGroups: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { groups, isLoading, error, selectedGroup } = useSelector((state: RootState) => state.prodGroup);
    const [isFormOpen, setIsFormOpen] = useState(false);

    const { input, setInput, handleChange, errors, submit, resetForm } = useForm(INIT_INPUT, handleSubmit, groupFormValidator);

    useEffect(() => {
        dispatch(fetchProdGroups());
    }, [dispatch]);

    useEffect(() => {
        if (!selectedGroup.id) return;
        setInput({ ...selectedGroup });
    }, [selectedGroup, setInput]);

    function handleSubmit() {
        const name = input.name.trim();
        const description = input.description.trim();
        const url = input.url;
        if (selectedGroup.id) {
            dispatch(updateProdGroup({ id: selectedGroup.id, name, description, url }));
        } else {
            dispatch(createProdGroup({ name, description, url }));
        }
        closeForm();
    }

    const openForm = () => setIsFormOpen(true);
    const closeForm = () => {
        setIsFormOpen(false);
        dispatch(removeSelectedProdGroup());
        resetForm();
    };

    const deleteHandler = (id: string) => {
        dispatch(deleteProdGroup(id));
    };
    const editHandler = (id: string) => {
        dispatch(selectProdGroup(id));
        openForm();
    };

    const isPlaceholderVisible = !isLoading && !error.isError && !isFormOpen && groups.length === 0;

    return (
        <Card>
            <div className={classes.promocodes}>
                <div className={classes.header}>
                    <h3 className={classes.title}>Группы товаров</h3>
                    <IconButton onClick={openForm} isDisabled={isFormOpen || error.isError}>
                        <AddIcon />
                    </IconButton>
                </div>
                {isLoading && <AreaLoader />}
                {!isLoading && error.isError && !isFormOpen && <Placeholder text={error.message} />} {isPlaceholderVisible && <Placeholder text="Нет групп" />}
                {isFormOpen && (
                    <SettingsForm
                        onClose={closeForm}
                        onChange={handleChange}
                        onSubmit={submit}
                        errors={errors}
                        value={input}
                        labelName="Название группы"
                        labelURL="Критерий различия"
                        namePlaceholder="Укажите название группы"
                        descriptionPlaceholder="Описание группы"
                        urlOptions={OPTIONS}
                    />
                )}
                {!isFormOpen && groups.length > 0 && <SettingsList items={groups} onEdit={editHandler} onDelete={deleteHandler} />}
            </div>
        </Card>
    );
};

export default ProdGroups;
